import { Tuple } from "components/Shared/Interfaces"
import { useIntl } from "react-intl"
import {
	AGE,
	GENDER,
	CHANNEL,
	SEGMENTATION,
	PSYCHOGRAPHICS,
	CUSTOMER_TYPE,
} from "components/Shared/GlobalFilter/constants"

const codesDefault: Record<string, Array<string>> = {
	[AGE]: ["over65", "55to65", "45to54", "35to44", "25to34", "18to24", "noInfo"],
	[GENDER]: ["female", "male", "noInfo"],
	[CHANNEL]: ["ALL", "STORES", "ECOMMERCE"],
	[SEGMENTATION]: ["cooper", "silver", "gold", "platinum", "new"],
	[PSYCHOGRAPHICS]: [
		"spontaneous",
		"optimizer",
		"flexible",
		"demanding",
		"noInfo",
	],
	[CUSTOMER_TYPE]: ["stores", "online", "omnichannel"],
}

export const OPTIONS = (
	choice: string,
	customCodes?: Record<string, Array<string>>
): Array<Tuple> => {
	const intl = useIntl()
	const codes = customCodes ? customCodes : codesDefault

	return codes[choice]?.map((item) => ({
		code: item,
		name: intl.formatMessage(
			{ id: `phronesis.filters.options.${choice}` },
			{ optionId: item }
		),
	}))
}
